/* src/app/modules/portal/components/useful-applications/useful-applications.component.scss */
.layout {
  display: grid;
  grid-template-columns: repeat(3, auto);
  gap: 0.5rem;
}
.layout > * {
  text-decoration: none;
}
sh-tool {
  --ui-1:
    0,
    0,
    0;
}
[title] {
  margin-bottom: 1rem;
}
#apps-icon {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
}
[screen-tablet] :host-context .layout {
  grid-template-columns: repeat(4, auto);
}
[screen-tablet] :host-context #info-icon {
  margin-top: 0px;
  margin-right: 28px;
}
[screen-phone] :host-context .layout {
  grid-template-columns: repeat(auto-fit, minmax(4rem, 1fr));
}
[screen-phone] :host-context #info-icon {
  margin-top: 0px;
  margin-right: 28px;
}
.title {
  display: flex;
  align-items: normal;
}
#info-icon {
  margin-block-start: -3px;
  margin-top: 2px;
  cursor: pointer;
}
/*# sourceMappingURL=useful-applications.component.css.map */
